export const sectionsInfo = {
  income_from_legal_person_to_holder: {
    name: 'Rendimentos Tributáveis Recebidos de Pessoa Jurídica pelo Titular',
    columns: {
      payer_name: { name: 'NOME DA FONTE PAGADORA', type: 'name' },
      income_from_legal_person: {
        name: 'REND. RECEBIDOS DE PES. JURÍDICA',
        type: 'currency',
        total_value_column: 'Total de Rend. Recebidos de Pes. Jurídica',
      },
      official_social_security_contribution: {
        name: 'CONTR. PREVID. OFICIAL',
        type: 'currency',
        total_value_column: 'Total de Contr. Previd. Oficial',
      },
      tax_withheld_at_source: {
        name: 'IMPOSTO RETIDO NA FONTE',
        type: 'currency',
        total_value_column: 'Total em Imposto Retido na Fonte',
      },
      thirteenth_salary: {
        name: '13º SALÁRIO',
        type: 'currency',
        total_value_column: 'Total em 13º Salário',
      },
      irrf_on_thirteenth_salary: {
        name: 'IRRF SOBRE 13º SALÁRIO',
        type: 'currency',
        total_value_column: 'Total em IRRF Sobre 13º Salário',
      },
      cpf_cnpj: { name: 'CNPJ/CPF', type: 'cpf_cnpj' },
    },
  },
  income_from_legal_person_to_dependents: {
    name: 'Rendimentos Tributáveis Recebidos de Pessoas Jurídicas pelos Dependentes',
    columns: {
      payer_name: { name: 'NOME DA FONTE PAGADORA', type: 'name' },
      income_from_legal_person: {
        name: 'REND. RECEBIDOS DE PES. JURÍDICA',
        type: 'currency',
        total_value_column: 'Total de Rend. Recebidos de Pes. Jurídica',
      },
      official_social_security_contribution: {
        name: 'CONTR. PREVID. OFICIAL',
        type: 'currency',
        total_value_column: 'Total de Contr. Previd. Oficial',
      },
      tax_withheld_at_source: {
        name: 'IMPOSTO RETIDO NA FONTE',
        type: 'currency',
        total_value_column: 'Total em Imposto Retido na Fonte',
      },
      thirteenth_salary: {
        name: '13º SALÁRIO',
        type: 'currency',
        total_value_column: 'Total em 13º Salário',
      },
      irrf_on_thirteenth_salary: {
        name: 'IRRF SOBRE 13º SALÁRIO',
        type: 'currency',
        total_value_column: 'Total em IRRF Sobre 13º Salário',
      },
      cpf_cnpj: { name: 'CNPJ/CPF', type: 'cpf_cnpj' },
      dependent_cpf: { name: 'CPF DO DEPENDENTE', type: 'cpf' },
    },
  },
  income_from_legal_person_to_holder_with_suspended_requirements: {
    name:
      'Rendimentos Tributáveis Recebidos de Pessoa Jurídica pelo Titular (Imposto com Exigibilidade Suspensa)',
    columns: {
      payer_name: { name: 'NOME DA FONTE PAGADORA', type: 'name' },
      cpf_cnpj: { name: 'CPF/CNPJ', type: 'cpf_cnpj' },
      taxable_income_with_suspended_requirements: {
        name: 'RENDIMENTOS TRIBUTÁVEIS',
        type: 'currency',
        total_value_column: 'Total de Rendimentos Tributáveis',
      },
      court_deposits_of_the_tax: {
        name: 'DEPÓSITOS JUDICIAIS DO IMPOSTO',
        type: 'currency',
        total_value_column: 'Total em Depósitos Judiciais de Impostos',
      },
    },
  },
  income_from_legal_person_to_dependents_with_suspended_requirements: {
    name:
      'Rendimentos Tributáveis Recebidos de Pessoa Jurídica pelos Dependentes (Imposto com Exigibilidade Suspensa)',
    columns: {
      payer_name: { name: 'NOME DA FONTE PAGADORA', type: 'name' },
      cpf_cnpj: { name: 'CPF/CNPJ', type: 'cpf_cnpj' },
      taxable_income_with_suspended_requirements: {
        name: 'RENDIMENTOS TRIBUTÁVEIS',
        type: 'currency',
        total_value_column: 'Total de Rendimentos Tributáveis',
      },
      court_deposits_of_the_tax: {
        name: 'DEPÓSITOS JUDICIAIS DO IMPOSTO',
        type: 'currency',
        total_value_column: 'Total em Depósitos Judiciais de Impostos',
      },
      dependent_cpf: { name: 'CPF DO DEPENDENTE', type: 'cpf' },
    },
  },
  accumulated_income_from_legal_person_to_holder: {
    name: 'Rendimentos Recebidos Acumuladamente de Pessoa Jurídica pelo Titular',
    columns: {
      payer_name: { name: 'Nome da Fonte Pagadora', type: 'name' },
      cpf_cnpj: { name: 'CPF/CNPJ', type: 'cpf_cnpj' },
      taxable_income_total: {
        name: 'Rend. Tributável Total',
        total_value_column: 'Total em Rend. Tributáveis',
        type: 'currency',
      },
      official_social_security_contribution: {
        name: 'Contrib. Prev. Oficial',
        total_value_column: 'Total em Contrib. Prev. Oficial',
        type: 'currency',
      },
      alimony: {
        name: 'Pensão Alimentícia',
        total_value_column: 'Total em Pensão Alimentícia',
        type: 'currency',
      },
      tax_withheld_at_source: {
        name: 'Imposto Retido na Fonte',
        total_value_column: 'Total em Imposto Retido na Fonte',
        type: 'currency',
      },
      tax_option: { name: 'Opção de Tributação', type: 'name', isHorizontal: true },
      month_of_receipt: { name: 'Mês Recebimento', type: 'name', isHorizontal: true },
      amount_received_related_to_interest: {
        name: 'Valor Referente a Juros',
        type: 'currency',
        isHorizontal: true,
      },
      number_of_months: { name: 'Nº de Meses', type: 'float', isHorizontal: true },
      tax_due_rra: { name: 'Imposto Devido RRA', type: 'currency', isHorizontal: true },
      exempt_portion_65_years: { name: 'Isenção +65 anos', type: 'currency', isHorizontal: true },
      feeding: {
        name: 'Alimentando',
        type: 'inner_table',
        columns: {
          name: { name: 'Nome', type: 'name' },
          value: { name: 'Valor', type: 'currency' },
        },
      },
    },
  },
  accumulated_income_from_legal_person_to_dependents: {
    name: 'Rendimentos Recebidos Acumuladamente de Pessoa Jurídica pelos Dependentes',
    columns: {
      payer_name: { name: 'Nome da Fonte Pagadora', type: 'name' },
      cpf_cnpj: { name: 'CPF/CNPJ', type: 'cpf_cnpj' },
      taxable_income_total: {
        name: 'Rend. Tributável Total',
        total_value_column: 'Total em Rend. Tributáveis',
        type: 'currency',
      },
      official_social_security_contribution: {
        name: 'Contrib. Prev. Oficial',
        total_value_column: 'Total em Contrib. Prev. Oficial',
        type: 'currency',
      },
      alimony: {
        name: 'Pensão Alimentícia',
        total_value_column: 'Total em Pensão Alimentícia',
        type: 'currency',
      },
      tax_withheld_at_source: {
        name: 'Imposto Retido na Fonte',
        total_value_column: 'Total em Imposto Retido na Fonte',
        type: 'currency',
      },
      tax_option: { name: 'Opção de Tributação', type: 'name', isHorizontal: true },
      month_of_receipt: { name: 'Mês Recebimento', type: 'name', isHorizontal: true },
      amount_received_related_to_interest: {
        name: 'Valor Referente a Juros',
        type: 'currency',
        isHorizontal: true,
      },
      number_of_months: { name: 'Nº de Meses', type: 'float', isHorizontal: true },
      tax_due_rra: { name: 'Imposto Devido RRA', type: 'currency', isHorizontal: true },
      exempt_portion_65_years: { name: 'Isenção +65 anos', type: 'currency', isHorizontal: true },
      feeding: {
        name: 'Alimentando',
        type: 'inner_table',
        columns: {
          name: { name: 'Nome', type: 'name' },
          value: { name: 'Valor', type: 'currency' },
        },
      },
    },
  },
}
